'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useState } from 'react';
import Main from '../Main';
export const WizardContext = /*#__PURE__*/ createContext(undefined);
export function Wizard({ initialState, initialStepId, steps, header, icons }) {
    const [state, setState] = useState(initialState);
    const [stepId, setStepId] = useState(initialStepId);
    const currentStep = steps.find((step)=>step.id === stepId);
    if (!currentStep) {
        throw new Error(`step ${stepId} not found`);
    }
    return /*#__PURE__*/ _jsx(WizardContext.Provider, {
        value: {
            state,
            setState,
            steps,
            stepId,
            setStepId,
            icons
        },
        children: /*#__PURE__*/ _jsxs("div", {
            className: containerStyle,
            "data-testid": "wizard",
            children: [
                header,
                /*#__PURE__*/ _jsx(Main, {
                    hasSidebar: false,
                    className: mainStyle,
                    children: currentStep.component
                })
            ]
        })
    });
}
const containerStyle = 'flex flex-col min-h-screen';
const mainStyle = 'mobile:grow';
